module.exports = __webpack_public_path__ + "static/img/logo_33.d6c5d7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo_33.png
// module id = T2RR
// module chunks = 1